import { render, staticRenderFns } from "./Panels.vue?vue&type=template&id=2ff76120&scoped=true&"
import script from "./Panels.vue?vue&type=script&lang=js&"
export * from "./Panels.vue?vue&type=script&lang=js&"
import style0 from "./Panels.vue?vue&type=style&index=0&id=2ff76120&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ff76120",
  null
  
)

export default component.exports